






































import Vue, { PropType } from 'vue';
import StoryCard from '@/components/StoryCard.vue';
import Story from '@/models/story';
import Snake from '@/components/Snake.vue';

export default Vue.extend({
  name: 'StoriesPanel',
  components: {
    StoryCard,
    Snake,
  },
  props: {
    stories: {
      type: Array as PropType<Array<Story>>,
      required: true,
    },
    headline: String,
    headlineSize: String,
    headlinePosition: String,
    colorScheme: {
      type: String,
      validator: (value: string) => [
        'green',
        'purple',
        'combo',
      ].indexOf(value) !== -1,
    },
    enableSnake: Boolean,
    enableVariants: Boolean,
    enableMoreStoriesLink: Boolean,
  },
});
